import React from "react";
import { useNavigate } from "react-router-dom";
import "../../styles/Legal.css";

const Cancellation = () => {
  const navigate = useNavigate();

  return (
    <div className="legal-page">
      <div className="logo" onClick={() => navigate("/")}>
        토익몬
      </div>

      <div className="legal-content">
        <div className="legal-header">
          <h1>환불 및 취소 정책</h1>
          <p>최종 업데이트: 2024년 5월 1일</p>
        </div>

        <div className="legal-sections">
          <section className="legal-section">
            <h2>1. 이용권 결제</h2>
            <p>
              1.1. 토익몬 서비스는 1회성 결제로 한달 이용권을 구매하는 방식으로
              운영됩니다.
            </p>
            <p>
              1.2. 이용권은 구매일로부터 30일간 유효하며, 자동 갱신되지
              않습니다.
            </p>
          </section>

          <section className="legal-section">
            <h2>2. 환불 정책</h2>
            <p>
              2.1. 토익몬은 디지털 콘텐츠 서비스로, 구매 즉시 전체 콘텐츠에 접근
              권한이 부여되는 특성상 구매 완료 후에는 환불이 제한됩니다.
            </p>
            <p>
              2.2. 디지털 콘텐츠의 특성상 한번 제공된 서비스는 반품이나 회수가
              불가능하므로, 결제 전 서비스 내용을 충분히 확인해 주시기 바랍니다.
            </p>
            <p>
              2.3. 체험판 또는 무료 체험 기간을 통해 서비스를 미리 경험해 보신
              후 구매를 결정하실 것을 권장합니다.
            </p>
          </section>

          <section className="legal-section">
            <h2>3. 예외적 환불 상황</h2>
            <p>
              3.1. 결제 직후 기술적 오류로 인해 서비스에 전혀 접근할 수 없는
              경우, 24시간 이내에 고객센터로 문의하시면 개별적으로 검토해
              드립니다.
            </p>
            <p>
              3.2. 법적으로 환불이 요구되는 상황에서는 관련 법규에 따라
              처리됩니다.
            </p>
          </section>

          <section className="legal-section">
            <h2>4. 서비스 이용</h2>
            <p>
              4.1. 이용권 구매 후 즉시 모든 학습 콘텐츠와 기능에 접근할 수
              있습니다.
            </p>
            <p>4.2. 이용 기간 만료 후에는 서비스 접근이 제한됩니다.</p>
          </section>

          <section className="legal-section">
            <h2>5. 서비스 품질 보증</h2>
            <p>
              5.1. 토익몬은 고품질의 학습 경험을 제공하기 위해 최선을 다하고
              있습니다.
            </p>
            <p>
              5.2. 서비스 이용 중 기술적 문제가 발생할 경우, 신속하게 해결해
              드리기 위해 노력하겠습니다.
            </p>
          </section>

          <section className="legal-section">
            <h2>6. 이용권 만료 후</h2>
            <p>
              6.1. 이용권 만료 후에는 토익몬의 콘텐츠와 기능에 접근할 수
              없습니다.
            </p>
            <p>
              6.2. 계속해서 서비스를 이용하시려면 새로운 이용권을 구매하셔야
              합니다.
            </p>
          </section>

          <section className="legal-section">
            <h2>7. 정책 변경</h2>
            <p>
              당사는 환불 및 취소 정책을 언제든지 변경할 권리를 보유합니다. 변경
              사항은 웹사이트를 통해 공지됩니다.
            </p>
          </section>

          <section className="legal-section">
            <h2>8. 문의하기</h2>
            <p>
              환불 및 취소 정책에 관한 질문이 있으시거나 도움이 필요하시면
              support@toeicmon.com으로 문의해 주세요.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Cancellation;
